import { render } from "./confirm-modal.vue?vue&type=template&id=0f58b0cf&scoped=true"
import script from "./confirm-modal.vue?vue&type=script&lang=js"
export * from "./confirm-modal.vue?vue&type=script&lang=js"

import "./confirm-modal.vue?vue&type=style&index=0&id=0f58b0cf&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f58b0cf"]])

export default __exports__